import { connect } from "react-redux";
import Dashboard from "../components/Dashboard/Dashboard";

import { GET_RELATED_USERS_REQUEST, PROFILE_INFO_REQUEST } from "../constants";
import { DASHBOARD_BARCODE_OPEN, GET_DASHBOARD_ALERTS_REQUEST, GET_DASHBOARD_DATA_REQUEST } from "../constants/dashboard.constants";

const mapStateToProps = (state: any) => {
	return {
		requesting: state.dashboard.requesting,
		successful: state.dashboard.successful,
		requestingAlerts: state.dashboard.requestingAlerts,
		successfulAlerts: state.dashboard.successfulAlerts,
		errors: state.dashboard.errors,
		messages: state.dashboard.messages,
		alerts: state.dashboard.alerts,
		dashboardData: state.dashboard.dashboardData,
		userConfig: state.auth.userConfig,
		user: state.client.user,
		data: state.dashboard.data,
		purchaseForUsers: state.client.purchaseForUsers,
		clubData: state.billingProfile.clubData,
		loadError: state.dashboard.loadError,
		barcodeOpened: state.dashboard.barcodeOpened,
		memberID: state.client.user?.memberID,
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {
		getDashboardAlerts: (config: any) =>
			dispatch({ type: GET_DASHBOARD_ALERTS_REQUEST, value: config }),
		getDashboardData: (config: any) =>
			dispatch({ type: GET_DASHBOARD_DATA_REQUEST, value: config }),
		getProfileInfo: (config: any) =>
			dispatch({ type: PROFILE_INFO_REQUEST, value: config }),
		getRelatedUsers: (config: any) =>
			dispatch({
				type: GET_RELATED_USERS_REQUEST,
				value: config,
			}),
		openBarcode: (opened: boolean) =>
			dispatch({ type: DASHBOARD_BARCODE_OPEN, value: opened }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
